import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts';
import { Card, CardBody, CardExpandToggler } from '../../other/card/card';
import ComponentLoader from '../../other/ComponentLoader';
import { useGetDetectedReportedRemovedQuery, useGetNumberOfCampaignsQuery } from '../../../redux/Api/AnalyticsApiSlice';
import generateStats from '../../Dashboard/data/stats';
import { toast } from 'react-toastify';

const OverallData = ({campaign_id}) => {
    const { data: detectedreportedRemovedCampaigns, isLoading: detectedLoading, error: detectedError } = useGetDetectedReportedRemovedQuery({ campaign_id: campaign_id })
    const { data: campaignsCount, isLoading: campaignsLoading, error: campaignsError } = useGetNumberOfCampaignsQuery()

    useEffect(() => {
        if (detectedError?.data) {
            const errorMessages = Object.values(detectedError.data).flat()
            errorMessages.forEach(message => {
                toast.error(message)
            })
        }
        if (campaignsError?.data) {
            const errorMessages = Object.values(campaignsError.data).flat()
            errorMessages.forEach(message => {
                toast.error(message)
            })
        }
    }, [detectedError, campaignsError])

    const [statsData, setStatsData] = useState();
    const [chartOptions, setChartOptions] = useState(getChartOptions());









    function getChartOptions() {
        var themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
        var themeColorRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();

        return {
            bar: {
                colors: [themeColor],
                chart: { sparkline: { enabled: true } },
                tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } }
            },
            line: {
                colors: [themeColor],
                chart: { sparkline: { enabled: true } },
                stroke: { curve: 'straight', width: 2 },
                tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } }
            },
            pie: {
                colors: ['rgba(' + themeColorRgb + ', 1)', 'rgba(' + themeColorRgb + ', .75)', 'rgba(' + themeColorRgb + ', .5)'],
                chart: { sparkline: { enabled: true } },
                stroke: { show: false },
                tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } }
            },
            donut: {
                colors: ['rgba(' + themeColorRgb + ', .15)', 'rgba(' + themeColorRgb + ', .35)', 'rgba(' + themeColorRgb + ', .55)', 'rgba(' + themeColorRgb + ', .75)', 'rgba(' + themeColorRgb + ', .95)'],
                chart: { sparkline: { enabled: true } },
                stroke: { show: false },
                tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } },
            }
        };
    }

    useEffect(() => {
        setStatsData(generateStats(campaignsCount, detectedreportedRemovedCampaigns))
        document.addEventListener('theme-reload', () => {
            setChartOptions(getChartOptions());
        });

    }, [campaignsCount, detectedreportedRemovedCampaigns]);
    return (
        <div className='flex justify-between gap-2'>
            {statsData && statsData.length > 0 && statsData.slice(2).map((stat, index) => (
                <div className="flex-grow" key={index}>
                    <Card className="mb-3">
                        <CardBody className="relative p-0">
                            {(campaignsLoading || detectedLoading) ? <ComponentLoader /> : null}
                            <div className='p-4'>
                                <div className="d-flex fw-bold small mb-3">
                                    <span className="flex-grow-1">{stat?.title}</span>
                                </div>
                                <div className="row align-items-center mb-2">
                                    <div className="col-7">
                                        <h4 className="mb-0">{stat?.total}</h4>
                                    </div>
                                    <div className="col-3">
                                        <div className="mt-n3">
                                            <Chart type={stat?.chartType} height={stat?.chartHeight} options={chartOptions[stat?.chartType]} series={stat?.chartData} />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="small text-inverse text-opacity-50 text-truncate">
                                    {stat.info?.length > 0 && stat.info.map((info, index) => (
                                        <div key={index}><i className={info?.icon}></i> {info?.text}</div>
                                    ))}
                                </div> */}
                            </div>
                        </CardBody>
                    </Card>
                </div>
            ))}
        </div>
    )
}

export default OverallData